import Base from './base'
import { Opportunity } from '../types/deal'
import {
  OpportunityApi,
  OpportunitiesApiResponse as AccountOpportunitiesApiResponse,
  OpportunitiesQueryParams as AccountOpportunitiesQueryParams,
  PersonOpportunitiesApiResponse,
  PersonOpportunitiesQueryParams,
} from '../types/opportunity'

export type GetOpportunitiesOptions = {
  crm_ids?: string[]
  person_crm_id?: string
  closest?: boolean
  name?: string
}
type OpportunitiesApiResponse = AccountOpportunitiesApiResponse | PersonOpportunitiesApiResponse
type OpportunitiesQueryParams = AccountOpportunitiesQueryParams | PersonOpportunitiesQueryParams

export default class Opportunities extends Base {
  async get(options?: GetOpportunitiesOptions): Promise<Opportunity[]> {
    const response = await this.api.get('opportunities', {
      params: { ...options, sort: 'close_date', reverse: true },
    })
    const data = Array.isArray(response) ? response : response?.data
    return data ?? []
  }

  async getAll(params: OpportunitiesQueryParams): Promise<OpportunitiesApiResponse> {
    return this.api.get('opportunities', { params })
  }

  async getById(id: string): Promise<OpportunityApi | null> {
    const response = await this.api.get(`opportunities/${id}`)
    return response?.data ?? null
  }
}
